import { ca } from '@cian/analytics';

export const trackBuilderLinkEvent = ({
  newbuildingId,
  action,
}: {
  newbuildingId: number;
  action: 'Show' | 'Click';
}) => {
  ca('teaser', {
    product: {
      name: `LinkToDeveloperSite${action}`,
      id: newbuildingId,
      extra: {
        place: 'featuring_cardJK_header_block',
        eventDate: Date.now(),
      },
    },
  });
};
